export type TaxType = TaxTypeNonZero | TaxTypeZero;
export type TaxTypeNonZero = 'legacy_tax' | 'reduced' | 'standard';

export type TaxTypeZero =
    | 'duty_free'
    | 'legacy_no_tax'
    | 'non_taxable'
    | 'untaxable';

const ZERO_TAX_TYPES = [
    'untaxable',
    'non_taxable',
    'duty_free',
    'legacy_no_tax',
];

export const isTaxTypeZero = (taxType: TaxType): taxType is TaxTypeZero =>
    ZERO_TAX_TYPES.includes(taxType);

export interface TaxCombination {
    isTaxInclusive: boolean;
    taxRate: string;
    taxType: TaxType;
}
